import { LoadingButtonProps } from '@mui/lab';

export default function MuiLoadingButton(): {
  MuiLoadingButton: {
    defaultProps: LoadingButtonProps;
  };
} {
  return {
    MuiLoadingButton: {
      defaultProps: {
        variant: 'contained',
        disableRipple: true,
      },
    },
  };
}
